import type { Role } from '@volee/api-client'

// Where a person lands after signing in. Why `/me` and why singular, and which facets
// coexist: apps/frontend/docs/quattro-profili-sotto-me.md.

export const PROFILE_PATHS = ['/me/official', '/me/coach', '/me/parent', '/me/player'] as const

export type ProfilePath = (typeof PROFILE_PATHS)[number]

interface ProfileForRole {
  readonly role: Role
  readonly path: ProfilePath
}

const PROFILES_BY_PRECEDENCE: readonly ProfileForRole[] = [
  { role: 'club', path: '/me/official' },
  { role: 'coach', path: '/me/coach' },
  { role: 'parent', path: '/me/parent' },
  { role: 'player', path: '/me/player' },
]

// `null` is the `guest` account: no facet, so no profile to open. `/` sends it to
// `/forbidden`, which offers it the only move it has — signing out.
export function profileFor(roles: readonly Role[]): ProfilePath | null {
  return PROFILES_BY_PRECEDENCE.find((profile) => roles.includes(profile.role))?.path ?? null
}
